import React from 'react';

const Services = () => {
  const services = [
    {
      title: "Eye-Typing Software",
      description: "Software for accessibility and easy communication using smartglasses.",
      icon: "👁️"
    },
    {
      title: "Smart Glasses",
      description: "Innovative smart glasses for enhanced user experience.",
      icon: "🕶️"
    },
    {
      title: "AI & Machine Learning",
      description: "Intelligent applications of cutting-edge AI technologies.",
      icon: "🤖"
    }
  ];

  return (
    <div 
      id="services" 
      className="py-16 bg-gray-50"
    >
      <div className="container mx-auto text-center">
        <h2 className="text-4xl font-bold mb-12 text-[#365DC9]">Our Products</h2>
        <div className="grid md:grid-cols-3 gap-8 px-4">
          {services.map((service, index) => (
            <div 
              key={index} 
              className="bg-white rounded-lg shadow-lg p-6 hover:shadow-xl transition duration-300"
            >
              <div className="text-6xl mb-4">{service.icon}</div>
              <h3 className="text-2xl font-semibold mb-4 text-[#36A6C9]">
                {service.title}
              </h3>
              <p className="text-gray-600">{service.description}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Services;